import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="components--turbo-frame-tabs"
export default class extends Controller {
  static targets = ["tab", "content"];
  static values = { initialTab: String };

  connect() {
    if (this.initialTabValue) {
      const tab = this.tabTargets.find((tab) =>
        tab.dataset.path.includes(this.initialTabValue),
      );
      tab?.click();
    }
  }

  activeTab(event) {
    const clickedTab = event.currentTarget;

    if (clickedTab.classList.contains("tab-active")) {
      event.preventDefault();
      return;
    }

    this.tabTargets.forEach((tab) => tab.classList.remove("tab-active"));
    clickedTab.classList.add("tab-active");
    window.history.pushState(
      null,
      "",
      clickedTab.dataset.path,
    );
  }

  showLoading() {
     this.contentTarget.innerHTML = `
        <div class="flex flex-col items-center justify-center py-16 text-center text-gray-400 animate-pulse">
          <svg class="w-10 h-10 mb-4 text-gray-300 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
          <p class="text-sm text-gray-400">Preparando información. Esperemos un momento por favor...</p>
        </div>
      `;
  }

  hideLoading() {
    this.contentTarget.innerHTML = "";
  }

  showError() {
    this.contentTarget.innerHTML = `
      <div class="flex flex-col items-center justify-center py-16 text-center text-error">
        <p class="text-sm font-medium">No se pudo cargar el contenido</p>
        <p class="text-xs text-base-content/60 mt-2">Intenta de nuevo o usa un rango de fechas más corto</p>
      </div>
    `;
  }
}
